export enum UserType {
  free = "free",
  b2c = "b2c",
  school_free = "school_free",
  school_premium = "school_premium",
  school_free_b2c = "school_free_b2c",
  school_premium_b2c = "school_premium_b2c"
}
